"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class CoreData {
    constructor(fresh, type, data) {
        let theData;
        if (fresh) {
            theData = data;
            const objVar = theData?.OBJECTID ? "OBJECTID" : "OBJECTID_1";
            this.identityInfo = IdentityInfo_1.default.genFromList(type, data, [
                objVar,
                "Abbrev",
                "CDPP",
                "CD_ID",
                "SLDU_ID",
                "SLDL_ID",
            ]);
        }
        else {
            theData = data;
            this.identityInfo = theData.identityInfo;
        }
        this.FREQUENCY = index_1.parseEsriNumber(data?.FREQUENCY);
        this.SUM_Total_Active_Fleet_auto = index_1.parseEsriNumber(data?.SUM_Total_Active_Fleet_auto);
        this.SUM_Beyond_Useful_Life_auto = index_1.parseEsriNumber(data?.SUM_Beyond_Useful_Life_auto);
        this.SUM_Total_Active_Fleet_bus = index_1.parseEsriNumber(data?.SUM_Total_Active_Fleet_bus);
        this.SUM_Beyond_Useful_Life_bus = index_1.parseEsriNumber(data?.SUM_Beyond_Useful_Life_bus);
        this.SUM_Total_Active_Fleet_rail = index_1.parseEsriNumber(data?.SUM_Total_Active_Fleet_rail);
        this.SUM_Beyond_Useful_Life_rail = index_1.parseEsriNumber(data?.SUM_Beyond_Useful_Life_rail);
        this.SUM_Total_Active_Fleet_ferry = index_1.parseEsriNumber(data?.SUM_Total_Active_Fleet_ferry);
        this.SUM_Beyond_Useful_Life_ferry = index_1.parseEsriNumber(data?.SUM_Beyond_Useful_Life_ferry);
        this.PCT_Beyond_Useful_Life_auto = index_1.parseEsriNumber(data?.PCT_Beyond_Useful_Life_auto);
        this.PCT_Beyond_Useful_Life_bus = index_1.parseEsriNumber(data?.PCT_Beyond_Useful_Life_bus);
        this.PCT_Beyond_Useful_Life_rail = index_1.parseEsriNumber(data?.PCT_Beyond_Useful_Life_rail);
        this.PCT_Beyond_Useful_Life_ferry = index_1.parseEsriNumber(data?.PCT_Beyond_Useful_Life_ferry);
        this.sum_passenger_trips = index_1.parseEsriNumber(data?.sum_passenger_trips);
        this.sum_passenger_miles = index_1.parseEsriNumber(data?.sum_passenger_miles);
        this.sum_formula_funding = index_1.parseEsriNumber(data?.sum_formula_funding);
        this.sum_fast_funding = index_1.parseEsriNumber(data?.sum_fast_funding);
        this.Fares_fund = index_1.parseEsriNumber(data?.Fares_fund);
        this.Local_fund = index_1.parseEsriNumber(data?.Local_fund);
        this.State_fund = index_1.parseEsriNumber(data?.State_fund);
        this.Federal_fund = index_1.parseEsriNumber(data?.Federal_fund);
        this.sum_cares_funding = index_1.parseEsriNumber(data?.sum_cares_funding);
        this.geometry = data?.geometry;
    }
    //orgURL= data.cst_url_code_dn
    getDoughnutData() {
        const valuesArr = [
            "Fares_fund",
            "Local_fund",
            "State_fund",
            "Federal_fund",
        ];
        const labelArr = [
            "Fares Funding",
            "Local Funding",
            "State Funding",
            "Federal Funding",
        ];
        let sum = 0;
        let values = [];
        let parsedValues = [];
        let parsedLabels = [];
        valuesArr.forEach((valueKey, index) => {
            let theValue = this?.[valueKey];
            if (theValue !== undefined && typeof theValue === "number") {
                values.push(theValue);
                sum += theValue;
                parsedLabels.push(labelArr[index]);
            }
        });
        parsedValues = values.map((rawValue, index) => {
            let theValue = ((rawValue / sum) * 100).toFixed(0);
            return theValue;
        });
        return {
            values,
            parsedValues,
            parsedLabels,
        };
    }
    static reinit(data) {
        const theType = data.identityInfo.type;
        return new CoreData(false, theType, data);
    }
    static init(theType, data) {
        return new CoreData(true, theType, data);
    }
}
exports.default = CoreData;
